"use strict";

var isMobileJS = window.isMobile;
if (!isMobileJS) throw new Error('isMobile.js is not found');

var browser = {
    desktop: isMobileJS.desktop,
    mobile: isMobileJS.any,
    phone: isMobileJS.phone,
    tablet: isMobileJS.tablet,
    landscape: function() {
        if (window.screen) {
            if (window.screen.orientation && window.screen.orientation.angle) {
                var angle = window.screen.orientation.angle;
                if (angle == 90 || angle == 270) return true;
                if (angle === 0 || angle == 180) return false;
            }

            if (window.screen.width && window.screen.height) {
                return window.screen.width > window.screen.height;
            }
        }

        return window.innerWidth > window.innerHeight;
    },
    // a main user interaction event name
    _userEvent: isMobileJS.any ? "touchstart" : "click"
};

export default browser;


// WEBPACK FOOTER //
// ./src/bindings/isMobile-browser.js